import { forwardRef } from 'react';
import { Platform, type Text as RnText } from 'react-native';

import { HeadingTextProps, Text } from '../text';

export type HeaderTitleTextProps = Partial<Omit<HeadingTextProps, 'children'>> & {
  text: string;
  /**
   * Use 2 when the screen already exposes an h1 elsewhere (e.g. VisuallyHiddenH1)
   * so the visible header title is the next level down (h2).
   */
  accessibilityLevel?: 1 | 2;
};

export const HeaderTitleText = forwardRef<RnText, HeaderTitleTextProps>(function HeaderTitleText(
  { text, accessibilityLevel = 1, ...props },
  ref
) {
  // Web: headings are not in the tab order by default; tabIndex 0 lets keyboard
  // users focus the page title (e.g. after “skip to content”).
  const webTabIndex = Platform.OS === 'web' ? (0 as const) : undefined;

  return (
    <Text.Heading
      ref={ref}
      type="four"
      accessibilityLevel={accessibilityLevel}
      accessible
      accessibilityLabel={text}
      tabIndex={webTabIndex}
      {...props}
    >
      {text}
    </Text.Heading>
  );
});
